<template>
  <div class="categoryMain">
    <b-card no-body
            class="dp02">
      <b-card-header header-tag="header"
                     role="tab">
        <b-button block
                  href="#"
                  @click="onClickHeader($event); $root.$emit('bv::toggle::collapse', `accordion-${categoryObj.name}`);"
                  :class="isASubcategory ? 'headerSubcategory' : 'headerCategory'">
          <h5>
            {{ categoryObj.name }}
            <b-badge v-if="categoryObj.waitingForProcessing"
                     variant="light">
              Nové {{ categoryObj.orderedAt }}
            </b-badge>
            <b-badge v-if="categoryObj.visible === false"
                     variant="light">
              Skryté
            </b-badge>
          </h5>
        </b-button>
      </b-card-header>
      <b-collapse :id="`accordion-${categoryObj.name}`"
                  :accordion="isASubcategory ? `${parentCategory}-accordion` : 'productAccordion'"
                  role="tabpanel">
        <b-card-body>
          <div v-if="categoryObj.description === null">
            {{ $t("DataTable.Loading") }}...
          </div>
          <div v-else
               v-html="categoryObj.description" />

          <div v-for="phenotype in categoryObj.phenotypes"
               :key="phenotype.id">
            <b-card no-body
                    class="dp02">
              <b-card-header header-tag="header"
                             role="tab">
                <b-button block
                          href="#"
                          @click="$root.$emit('bv::toggle::collapse', `accordion-${phenotype.name}`)"
                          class="phenotypeHeader">
                  <h5>{{ phenotype.name }}</h5>
                </b-button>
              </b-card-header>
              <b-collapse :id="`accordion-${phenotype.name}`"
                          :accordion="`${categoryObj.name}-accordion`"
                          role="tabpanel">
                <b-card-body>
                  <div v-html="phenotype.description" />
                  <div :class="'Risk'+phenotype.risk"
                       v-html="phenotype.resultPartOne" />
                  <div
                    v-html="phenotype.resultPartTwo" />
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
          <div v-for="subcategory in categoryObj.subcategories"
               :key="subcategory.name"
               class="dp02 my-5 p-2">
            <h4>{{ $t('common.Subcategories') }} {{ categoryObj.name }}</h4>
            <CategoryDisplay :category="subcategory"
                             :is-a-subcategory="true"
                             :parent-category="categoryObj.name" />
          </div>
          <div v-if="categoryObj.geneInformation !== undefined
            && categoryObj.geneInformation !== null
            && categoryObj.geneInformation.length != 0"
            class="gene-information">
            <h4>{{ $t('common.GeneticResults') }} {{ categoryObj.name }}</h4>
            <b-table
              show-empty
              striped
              borderless
              dark
              hover
              responsive
              sticky-header="550px"
              :items="categoryObj.geneInformation"
              :fields="headerFields" />
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  name: 'CategoryDisplay',
  props: {
    category: {
      type: Object,
      required: true
    },
    isASubcategory: {
      type: Boolean,
      required: false,
      default: false
    },
    parentCategory: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      categoryObj: {},
      categoryFetchInitiated: false
    };
  },
  computed: {
    headerFields: {
      get() {
        return Object.keys(this.category.geneInformation[0])
          .map((x) => {
            return {
              key: x,
              label: this.$t(`fields.geneInformation.${x}`)
            };
          });
      }
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'editProduct/setProductCategory' && this.categoryObj.phenotypes != null) {
        this.mapPhenotypes();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
    this.categoryObj = this.category;

    this.mapPhenotypes();

    const headerButtons = document.getElementsByClassName('headerCategory');
    // eslint-disable-next-line no-restricted-syntax
    for (const header of headerButtons) {
      header.addEventListener('click', this.scrollToCategory);
    }
  },
  methods: {
    ...mapMutations({
      setProductCategoryId: 'editProduct/setProductCategoryId'
    }),
    ...mapActions({
      fetchCategory: 'editProduct/fetchCategory'
    }),
    onClickHeader(e) {
      const offset = document.getElementsByClassName('result-edit')[0].getBoundingClientRect().top
      document.body.scrollBy({
        top: offset,
        left: 0,
        behavior: 'smooth'
      })
      if (!this.categoryFetchInitiated) {
        this.categoryFetchInitiated = true;
        this.setProductCategoryId(this.categoryObj.id);
        this.fetchCategory().finally(() => {
          this.scrollToCategory(e)
        })
      } else {
        setTimeout(() => {
          this.scrollToCategory(e)
        }, 500)
      }
    },
    scrollToCategory(e) {
      const offset = e.target.closest('.categoryMain').closest('div').offsetTop - 53;
      if (document.getElementsByClassName('viewingProduct').length > 0) {
        document.getElementsByClassName('viewingProduct')[0].scroll({
          top: offset,
          left: 0,
          behavior: 'smooth'
        })
      } else {
        // document.getElementsByClassName('editingProduct')[0].scrollTop = offset;
        document.getElementsByClassName('editingProduct')[0].scroll({
          top: offset,
          left: 0,
          behavior: 'smooth'
        })
      }
    },
    mapPhenotypes() {
      if (this.categoryObj.phenotypes != null) {
        this.categoryObj.phenotypes = this.categoryObj.phenotypes.map((x) => {
          const search = /<img/g;
          const replace = '<img style=\'max-width:750px\'';
          x.result = x.result.replace(search, replace);
          x.description = x.description.replace(search, replace);
          if (x.result !== null) {
            let separator = '';
            if (x.result.includes('Komentář a doporučení')) {
              separator = 'Komentář a doporučení';
            }
            else {
              separator = 'Comments and recommendations';
            }
            const parts = x.result.split(separator).map((item, i) => (i === 0 ? `${item}</strong></p>` : `<p><strong>${separator}${item}`));
            return { ...x, resultPartOne: parts[0], resultPartTwo: parts[1] };
          }
          return { ...x, resultPartOne: '', resultPartTwo: '' };
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.headerCategory {
  background-color:$primary-color;
  color: rgba(255, 255, 255, 0.65);
}

.headerSubcategory {
  background-color:$primary-variant-color;
  color: rgba(255, 255, 255, 0.65);
}

.phenotypeHeader {
  background-color: $primary-variant-color;
  color: rgba(255, 255, 255, 0.65);
}

.Risk1 {
  background-color: #e6f1e6;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  padding: 10px;
}

.Risk2 {
  background-color: #f9eae1;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  padding: 10px;
}

.Risk3 {
  background-color: #fde1e1;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  padding: 10px;
}

.Risk4 {
  background-color: #e1eff9;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  padding: 10px;
}

.card-header {
  padding: 0 !important;
}
</style>
